import Logo from "../assets/images/logo-sems.svg";
import SettingIcon from "../assets/icons/svg/icon-admin.svg";
import OperationIcon from "../assets/icons/svg/icon-operation.svg";
import Entroposage from "../assets/icons/svg/icon-storage.svg";
import Customer from "../assets/icons/svg/icon-customer.svg";
import Materials from "../assets/icons/svg/icon-material.svg";
import Employee from "../assets/icons/svg/icon-employee.svg";
import ArrowBack from "../assets/images/back-icon.svg";
import AddBox from "../assets/images/box.svg";
import ChalandIcon from "../assets/icons/svg/Chaland.svg";
import GrueIcon from "../assets/icons/svg/grue.svg";
import LevageIcon from "../assets/icons/svg/Levage.svg";
import MachineIcon from "../assets/icons/svg/Machine.svg";
import RemorqueurIcon from "../assets/icons/svg/remorqeur.svg";
import DashboarIcon from "../assets/icons/svg/dashboard.svg";

export const Assets = {
  icons: {
    png: {
      pdf: require("../assets/icons/png/pdf-download.png"),
      excel: require("../assets/icons/png/excel-download.png"),
    },
  },
  iconsSvg: {
    setting: SettingIcon,
    operation: OperationIcon,
    entroposage: Entroposage,
    customer: Customer,
    materials: Materials,
    employee: Employee,
    backArrow: ArrowBack,
    addBox: AddBox,
    barge: ChalandIcon,
    crane: GrueIcon,
    lifting: LevageIcon,
    machine: MachineIcon,
    tugboat: RemorqueurIcon,
    dashboard: DashboarIcon,
  },
  images: {
    ukas: require("../assets/images/ukas.png"),
    sgs: require("../assets/images/sgs.png"),
    headForm: require("../assets/images/head-bg.jpeg"),
    avatarThumb: require("../assets/images/avatar-thumb.png"),
    cabotage: require("../assets/images/cabotage.png"),
    equipement_management: require("../assets/images/equipement_management.png"),
    tools: require("../assets/images/outils.png"),
    ships: require("../assets/images/ship.png"),
    attach: require("../assets/images/attach-file.png"),
    calendar: require("../assets/images/calendar-light.png"),
    diagram: require("../assets/images/solar_diagram.png"),
    file: require("../assets/images/file.png"),
    operator: require("../assets/images/operator.png"),
    capacity: require("../assets/images/Ellipse 15 (1).png"),
    material: require("../assets/images/material.png"),
    warehouse: require("../assets/images/warehouse.png"),
    pile: require("../assets/images/boxes.png"),
    task: require("../assets/images/Group 1270.png"),
    dashboard: require("../assets/images/dashboard.png"),
    entreprise: require("../assets/images/entreprise.png"),
    eye: require("../assets/images/eye-broken.png"),
    operationFile: require("../assets/images/document-broken.png"),
  },
  imagesSvg: {
    logo: Logo,
  },
};
